import { useState, useEffect, useCallback } from 'react'

const RECENT_SEARCHES_KEY = 'sportspot_recent_searches'
const MAX_RECENT_SEARCHES = 5

export function useRecentSearches() {
  const [recentSearches, setRecentSearches] = useState<string[]>([])

  // Load recent searches from localStorage on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem(RECENT_SEARCHES_KEY)
      if (saved) {
        setRecentSearches(JSON.parse(saved))
      }
    } catch (error) {
      console.error('Error loading recent searches:', error)
    }
  }, [])

  // Add a search to recent searches
  const addRecentSearch = useCallback((search: string) => {
    const trimmed = search.trim()
    if (!trimmed || trimmed.length < 2) return

    setRecentSearches(prev => {
      // Remove if already exists
      const filtered = prev.filter(s => s.toLowerCase() !== trimmed.toLowerCase())
      // Add to front
      const updated = [trimmed, ...filtered].slice(0, MAX_RECENT_SEARCHES)

      // Save to localStorage
      try {
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated))
      } catch (error) {
        console.error('Error saving recent searches:', error)
      }

      return updated
    })
  }, [])

  // Remove a specific search
  const removeRecentSearch = useCallback((search: string) => {
    setRecentSearches(prev => {
      const updated = prev.filter(s => s !== search)

      try {
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated))
      } catch (error) {
        console.error('Error saving recent searches:', error)
      }

      return updated
    })
  }, [])

  // Clear all recent searches
  const clearRecentSearches = useCallback(() => {
    setRecentSearches([])
    try {
      localStorage.removeItem(RECENT_SEARCHES_KEY)
    } catch (error) {
      console.error('Error clearing recent searches:', error)
    }
  }, [])

  return {
    recentSearches,
    addRecentSearch,
    removeRecentSearch,
    clearRecentSearches
  }
}
